@if (view$ | async; as view) {
    <mobi-ui-header-major
        (logoClick)="handleLogoClick(view.language, view.portal)"
        [headerLogo]="view.headerLogo"
    >
        <div class="header-items">
            <a
                data-test-id="osm-header-user"
                class="osm-user is-clickable"
                [mobiUiPopover]="userPopover"
            >
                <mobi-ui-icon-major name="user"></mobi-ui-icon-major>
                @if (view.name) {
                    <span>{{ view.name }}</span>
                }
                <input
                    type="hidden"
                    data-test-id="osm-header-partnernummer"
                    [value]="view.partnerNummer"
                />
                <input type="hidden" data-test-id="osm-header-cnumber" [value]="view.cnumber" />
            </a>
            <ng-template #userPopover>
                <mobi-ui-popover-major>
                    <ul class="mobi-ui-list-silent">
                        @if (view.renderLogin) {
                            <li>
                                <button class="mobi-ui-btn-minor" (click)="login()">
                                    {{ 'osm.header.login' + view.translationKeySuffix | translate }}
                                </button>
                            </li>
                        }
                        <li>
                            <button class="mobi-ui-btn-major" (click)="logout()">
                                {{ 'osm.header.logout' + view.translationKeySuffix | translate }}
                            </button>
                        </li>
                    </ul>
                </mobi-ui-popover-major>
            </ng-template>
        </div>
    </mobi-ui-header-major>
}
<app-messages></app-messages>
